<template>
  <div class="video-detail">
    <video
      :src="atSelectVideo.audioUrl"
      controls
      :poster="atSelectVideo.imageUrl"
      class="detail-video"
      controlslist="nodownload"
      ref="video"
      :autoplay="isAudioPlay"
    />
    <MediaList
      :mediaList="videoList"
      :switchMedia="switchVideo"
      :atSelectMedia="atSelectVideo"
      :mediaState="playing"
    />
  </div>
</template>

<script>
import MediaList from "./MediaList";
export default {
  props: {
    videoList: {
      type: Array,
      default: [],
    },
    atSelectVideo: {
      type: Object,
      default: "",
    },
    switchVideo: {
      type: Function,
      default: () => console.log("切换音频"),
    },
  },
  data() {
    return {
      playing: false,
      isAudioPlay: false
    };
  },

  mounted() {
    // 移除video 右下角三个点
    this.player["disablePictureInPicture"] = true;
    this.player.addEventListener(
      "playing",
      () => {
        this.playing = true;
      },
      false
    );
    this.player.addEventListener(
      "pause",
      () => {
        this.playing = false;
      },
      false
    );
  },

  components: {
    MediaList,
  },
  computed: {
    player() {
      return this.$refs.video;
    },
  },
  watch: {
    atSelectVideo(preItem, oddItem) {
      this.atSelectVideo = preItem;
      console.log("this.player", this.player);
      if (preItem.audioUrl != oddItem.audioUrl && oddItem) {
        this.isAudioPlay = true
        this.player.play()
      }
    },

    playing(value) {
      console.log(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../style/main";
.detail-video {
  width: 100%;
  height: rem(420);
  // object-fit: fill;
  vertical-align: top;
}
</style>